<template>
    <Head v-if="booking!=null" :title="booking.id" />
    <div class="loader" v-if="loading">
        <p>Please Wait....</p>
    </div>
    <div v-if="booking!=null">
        <nav class="navbar navbar-expand navbar-primary navbar-dark">
            <!-- Left navbar links -->
            <ul class="navbar-nav">
                <li class="nav-item">
                    <a class="nav-link"  href="#" role="button">Booking ID - {{booking.id}}</a>

                </li>


            </ul>

            <!-- Right navbar links -->
            <ul class="navbar-nav ml-auto">


                <li class="nav-item ml-2" v-bind:class="{ 'bg-warning': booking.status=='Pending' ,'bg-red':booking.status=='Closed','bg-success':booking.status=='Converted','bg-info':booking.status=='InProgress'}">
                    <a class="nav-link"  href="#" role="button">{{booking.status}}</a>

                </li>

            </ul>
        </nav>
        <section class="content pt-3 pagedetails">
            <div class="container-fluid">
                <el-row>
                    <el-col :span="5">
                        <el-card class="box-card m-2 p-0">
                            <template #header>
                                <div class="card-header">
                                    <span>Booking Detail</span>
                                </div>
                            </template>
                            <ul class="ml-0 mb-0 fa-ul text-muted">
                                <li class="small"><b>Booked ID :</b> {{booking.booking_id}}</li>
                                <li class="small"><b>Phone :</b> {{booking.phone}}</li>
                                <li class="small"><b>Email :</b> {{booking.email}}</li>
                                <li class="small"><b>Source :</b> {{booking.source}}</li>
                                <li class="small"><b>Destination :</b> {{booking.destination}}</li>
                                <li class="small"><b>Travel Date :</b> {{booking.travelStartDate}}</li>
                                <li class="small"><b>Booked On :</b> {{booking.booking_date}}</li>
                                <li class="small"><b>Payment Status :</b> {{booking.payment}}</li>
                                <li class="small"><b>Services :</b> <el-tag class="mr-2" v-for="service in booking.services" style="" >
                                    {{service}}</el-tag>
                                </li>


                            </ul>
                        </el-card>
                    </el-col>
                    <el-col :span="19">
                        <el-card class="box-card m-2 p-0" v-if="booking.flightdetails!=null">
                            <template #header>
                                <div class="card-header">
                                    <span>Flights</span>
                                </div>
                            </template>

                            <el-card class="box-card m-2 p-0" v-for="flight in booking.flightdetails.flights">
                                <template #header>
                                    <div class="card-header">
                                        <span>{{ flight.from.city}} - {{ flight.to.city}} <el-text class="mx-1" size="small">on {{ momentdate(flight.departure_datetime)}}</el-text></span>

                                        <el-tag class="ml-2">{{ flight.class}}</el-tag>

                                        <el-tag class="ml-2" type="success" v-if="flight.pricedetails.refundable">Refundable</el-tag>
                                        <el-tag class="ml-2" type="danger" v-else>Non Refundable</el-tag>
                                    </div>
                                </template>
                                <el-row v-for="(subflight,index) in flight.flights">
                                    <el-col :span="5">
                                        <el-row><el-text class="mx-1" tag="b">{{subflight.airline.name}}</el-text></el-row>
                                        <el-row><el-text class="mx-1" >{{subflight.flight_code}}</el-text></el-row>

                                    </el-col>
                                    <el-col :span="6">
                                        <el-row><el-text class="mx-1" tag="b" size="large">{{momentdatetime(subflight.departure_datetime)}}</el-text></el-row>
                                        <el-row><el-text class="mx-1" >{{subflight.from.city}} - {{subflight.from.code}}</el-text></el-row>
                                        <el-row><el-text class="mx-1" >{{subflight.from.name}}</el-text></el-row>

                                    </el-col>
                                    <el-col :span="5">
                                        <el-row>
                                            <el-col  :span="24">
                                            <el-text class="mx-1" tag="b" size="large">{{ mintoHM(subflight.duration) }}</el-text>
                                            </el-col>
                                        </el-row>

                                    </el-col>
                                    <el-col :span="7">
                                        <el-row><el-text class="mx-1" tag="b" size="large">{{momentdatetime(subflight.arrival_datetime)}}</el-text></el-row>
                                        <el-row><el-text class="mx-1" >{{subflight.to.city}} - {{subflight.to.code}}</el-text></el-row>
                                        <el-row><el-text class="mx-1" >{{subflight.to.name}}</el-text></el-row>

                                    </el-col>

                                    <el-col v-if="flight.layovers[index]" :span="24" >
                                        <el-alert class="mt-5 mb-5" center :title="mintoHM(flight.layovers[index].duration)+' Layover'" type="info" :closable="false"/>

                                    </el-col>

                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <el-divider></el-divider>
                                        <el-row><el-text class="mx-1" tag="b" size="large">Baggage Information</el-text></el-row>
                                        <el-row v-for="bag in flight.pricedetails.baggagerules"><el-text class="mx-1" tag="b">{{ bag.type }} - </el-text> Cabin: {{ bag.cabin }} |   Check-In: {{ bag.checkin }}</el-row>


                                    </el-col>
                                </el-row>




                            </el-card>

                            <el-card class="box-card m-2 p-0" >
                                <template #header>
                                    <div class="card-header">
                                        FARE SUMMARY
                                    </div>
                                </template>

                                <el-row>
                                    <el-col :span="24">
                                        <ul class="ml-0 mb-0 fa-ul text-muted">

                                            <li v-for="pxfr in booking.flightdetails.faresummary.paxwise">
                                                <b> {{ pxfr.type }} -</b> {{ pxfr.count }} X {{ pxfr.basefare }} = {{ pxfr.totalbasefare }}
                                            </li>

                                            <li>
                                               <b>Total Base fare -</b> {{ booking.flightdetails.faresummary.totalbf }}
                                            </li>
                                            <li>
                                                <b> Taxes and fees -</b> {{ booking.flightdetails.faresummary.taxes }}
                                            </li>
                                            <li>
                                                <b> Service Charges -</b> {{ booking.flightdetails.faresummary.service_charge }}
                                            </li>
                                            <li v-if="booking.flightdetails.faresummary.discount>0">
                                                <b> Discount -</b> {{ booking.flightdetails.faresummary.discount }}
                                            </li>
                                            <li>
                                                <b>  Total fare -</b> {{ booking.flightdetails.faresummary.total }}
                                            </li>
                                        </ul>
                                    </el-col>
                                </el-row>


                            </el-card>
                            <el-card class="box-card m-2 p-0" >
                                <template #header>
                                    <div class="card-header">
                                        Passenger Details
                                    </div>
                                </template>

                                <el-row>
                                    <el-col :span="24" v-for="pax in booking.flightdetails.paxdetails">
                                        <ul class="ml-0 mb-0 fa-ul text-muted">
                                            <li>
                                                <b> {{ pax.title }} {{ pax.fname }} {{ pax.lname }} ({{ pax.type }})</b>
                                                <span class="ml-2" v-if="pax.dob.day!=null">DOB - {{ pax.dob.day }} {{ pax.dob.month }} {{ pax.dob.year }} </span>
                                                <span v-if="pax.passport.number!=null">
                                                     <span class="ml-2">
                                                    Passport - {{ pax.passport.number }}
                                                         </span>
                                                    <span class="ml-2">
                                                         N:{{ pax.passport.nationalityCode }}
                                                    </span>
                                                    <span class="ml-2">
                                                      ID:{{ pax.passport.issueddate.day }} {{ pax.passport.issueddate.month }} {{ pax.passport.issueddate.year }}
                                                    </span>
                                                    <span class="ml-2">
                                                        ED:{{ pax.passport.expiry.day }} {{ pax.passport.expiry.month }} {{ pax.passport.expiry.year }}
                                                    </span>



                                                </span>


                                            </li>

                                        </ul>
                                    </el-col>
                                </el-row>


                            </el-card>
                            <el-card class="box-card m-2 p-0" v-if="booking.flightdetails.isgst==1" >
                                <template #header>
                                    <div class="card-header">
                                        Gst Details
                                    </div>
                                </template>

                                <el-row>
                                    <el-col :span="24" >
                                        <el-row><el-text class="mx-1" tag="b" size="large">Name - </el-text>{{ booking.flightdetails.gst_details.name }}</el-row>
                                        <el-row><el-text class="mx-1" tag="b" size="large">Gst Number - </el-text>{{ booking.flightdetails.gst_details.number }}</el-row>
                                        <el-row><el-text class="mx-1" tag="b" size="large">E-mail - </el-text>{{ booking.flightdetails.gst_details.email }}</el-row>
                                        <el-row><el-text class="mx-1" tag="b" size="large">Phone - </el-text>{{ booking.flightdetails.gst_details.phone }}</el-row>
                                        <el-row><el-text class="mx-1" tag="b" size="large">Address - </el-text>{{ booking.flightdetails.gst_details.address }}</el-row>
                                    </el-col>
                                </el-row>


                            </el-card>
                        </el-card>
                    </el-col>
                </el-row>

            </div>
        </section>




        <div class="modal fade" id="modal-bookingstage">
            <div class="modal-dialog">
                <div class="modal-content">
                    <form ref="form" @submit.prevent="savebookingstage" >
                        <div class="modal-header">
                            <h4 class="modal-title">Booking Stage</h4>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label >Stage</label>
                                        <select class="form-control" v-model="tempform.bookingstage.stage" >
                                            <option>Booked</option>
                                            <option>Postponed</option>
                                            <option>Cancelled</option>
                                        </select>


                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="modal-footer justify-content-between">
                            <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                            <button type="submit" class="btn btn-primary" >Save changes</button>
                        </div>
                    </form>
                </div>
                <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
        </div>


    </div>





</template>

<script>
import $ from 'jquery';
import moment from 'moment';
import  { ElAlert,ElText,ElSelect, ElOption,ElDatePicker,ElFormItem,ElForm,ElCol,ElRow,ElButton,ElCard,ElTag,ElAvatar,ElDivider,ElSkeleton  } from 'element-plus'
import 'element-plus/dist/index.css'

export default {
    name: "ViewOnlineBooking",
    props:['id'],
    components: { ElAlert,ElText,ElSelect,ElOption,ElDatePicker,ElFormItem,ElForm,ElCol,ElRow,ElButton,ElCard,ElTag,ElAvatar,ElDivider,ElSkeleton },
    data() {
        return {
            loading:false,
            booking:null,
            authuser:null,
            currentactiontitle:'',
            noteactions:{
                qc:["Customer is Intrested"],
                notreachable:["Call not Picked","Phone number doesn't work","Couldn't talk to traveler this time, try again later","Tried enough, leave the lead"],
                wontbook:["Dupe Enquiry","Traveler is not sure about the plan/cancelled plan","Traveler booked with someone else","Low Budget","Not Intrested","Regarding Job","Didnt Enquiry","Fake Enquiry","Just Enquiry","Test Enquiry"],
                talkinprogress:["Had Initial Talk","Quotation Sent","Initial stage only - Quote not seen","Getting Quote/package customized","Traveler interested, but will book after few weeks"],
                willfinalize:["Negotiating / Will finalize in 2 to 3 days","Invoice sent to traveler","Traveler will pay soon on my invoice"]


            },
            tempform:{
                bookingstage:{
                  stage :''
                }
           }
        }
    },
    mounted() {
        this.getdetails();
    },
    created() {



    },
    methods: {
        editbookingstage(){

            this.tempform.bookingstage.stage=this.booking.stage;

        },
        getdetails() {

            let currentObj = this;
            axios.get('/onlinebooking/viewdetails?id='+this.id).then(function (response) {
                currentObj.booking=response.data.booking;
                currentObj.authuser=response.data.user;

            })
                .catch(function (error) {
                });
        },
        momentdate(date){
            return moment(date).format('ddd, D MMM YY');
        },
        momentdatetime(date){
            return moment(date).format('ddd, D MMM YY HH:mm');
        },
        mintoHM(totalMinutes){
            const hours = Math.floor(totalMinutes / 60);
            const minutes = totalMinutes % 60;

            return hours+"h "+minutes+"m ";
        },





    }
}
</script>

<style scoped>

</style>
